<!-- Chart Card Container -->
<div class="flex h-full flex-col">
    <!-- Chart Header -->
    <div class="mb-4 flex flex-wrap items-center justify-between gap-3">
        <h3 class="text-base font-semibold text-slate-800">
            {{ 'translate_target_vs_result' | translate }}
        </h3>

        <!-- Toggle for showing values -->
        <app-toggle-switch
            [label]="'translate_hide_show_results' | translate"
            [(ngModel)]="hideShowResultStatus"
            (valueChange)="onToggle()"
        ></app-toggle-switch>
    </div>

    <!-- Year Filter -->
    <div class="mb-4">
        <label class="mb-1.5 block text-sm font-medium text-slate-600">
            {{ 'translate_years' | translate }}
        </label>
        <ng-select
            [items]="years"
            [multiple]="true"
            appClearSearchOnSelect
            [placeholder]="'translate_select_years' | translate"
            [(ngModel)]="selectedYears"
            (change)="redrawChart()"
            [clearable]="true"
            class="chart-year-select"
        >
        </ng-select>
    </div>

    <!-- Chart Canvas -->
    <div class="min-h-[280px] flex-1">
        <canvas #canvasRef></canvas>
    </div>
</div>
